import {
  shouldHideAllDistributorInfo,
  getRetailerUserAuthenticationStatus,
} from "@shared/services/retailer_user_authentication_service";

import { loadRetailerUserAuthentications } from "@retailer/services/retailer_user_authentications_service";
import type { SvelteComponent } from "svelte";

export type ControlStateIntegration = {
  state: string;
  text1: string;
  text2: string;
  connectCta: string;
  verifyCta: string;
  pendingDescription: string;
  invalidDescription: string;
  invalidTitle: string;
  actionBarTitle: string;
  actionBarDescription: string;
  shouldHideAllDistributorInfo: (
    retailerUserAuthentications: any[],
    distributorIds?: number[],
  ) => boolean;
  getRetailerUserAuthenticationStatus: (
    retailerUserAuthentications: any[],
    distributorIds?: number[],
  ) => "valid" | "invalid" | "pending" | null | undefined;
  startVerification: (status: string, attrs?: Record<string, any>) => void;
  refresh: () => Promise<any>;
  loginUrl?: () => string;
  bannerComponent: typeof SvelteComponent;
  ctaComponent: typeof SvelteComponent;
  cartCtaComponent: typeof SvelteComponent;
  plpCtaComponent: typeof SvelteComponent;
  actionBarCtaComponent: typeof SvelteComponent;
  authenticationModalComponent: typeof SvelteComponent;
};

export const baseIntegration = {
  shouldHideAllDistributorInfo: shouldHideAllDistributorInfo,
  getRetailerUserAuthenticationStatus: getRetailerUserAuthenticationStatus,
  startVerification: () => {
    throw new Error("Not implemented");
  },
  refresh: () => {
    return loadRetailerUserAuthentications(true);
  },
};
